export default {
  role: {
    roleId: "Role ID",
    roleName: "Role Name",
    description: "Role Description",
    role: "Role",
    roleNameExist: "Role name is already existed"
  }
};
